export default "__VITE_ASSET__BdurNELc__"